import {MOVE_TO_PAGE, PREVIOUS_PAGE, SET_PAGE, SET_RESET_PASSWORD_STEP} from "../actions/PageActions";

const PAGE_QUERY_PARAM = 'step';

function hydratePage() {
    try {
        const n = parseInt(new URLSearchParams(window.location.search).get(PAGE_QUERY_PARAM), 10);
        return Number.isFinite(n) && n >= 0 ? n : 0;
    } catch {
        return 0;
    }
}

function persistPage(page) {
    try {
        const url = new URL(window.location.href);
        if (page > 0) url.searchParams.set(PAGE_QUERY_PARAM, String(page));
        else url.searchParams.delete(PAGE_QUERY_PARAM);
        window.history.replaceState(window.history.state, '', url.toString());
    } catch {}
}

const initialState = {
    page: hydratePage(),
    moveTo: undefined,
    resetPasswordStep: null,
};

export default function PageReducer(state = initialState, action) {
    switch (action.type) {
        case SET_PAGE:
            persistPage(action.payload);
            return {
                ...state,
                page: action.payload,
            }

        case PREVIOUS_PAGE: {
            const nextPage = Math.max(state.page - 1, 0);
            persistPage(nextPage);
            return {
                ...state,
                page: nextPage,
            }
        }

        case MOVE_TO_PAGE:
            return {
                ...state,
                moveTo: action.payload,
            }

        case SET_RESET_PASSWORD_STEP:
            return {
                ...state,
                resetPasswordStep: action.payload,
            }
    }

    return state
}